/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiKeyCreationResult
 */
export interface ApiKeyCreationResult {
  /**
   *
   * @type {string}
   * @memberof ApiKeyCreationResult
   */
  apiKeyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiKeyCreationResult
   */
  keyValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiKeyCreationResult
   */
  keyPrefix: string;
}

/**
 * Check if a given object implements the ApiKeyCreationResult interface.
 */
export function instanceOfApiKeyCreationResult(
  value: object,
): value is ApiKeyCreationResult {
  if (!("apiKeyId" in value) || value["apiKeyId"] === undefined) return false;
  if (!("keyValue" in value) || value["keyValue"] === undefined) return false;
  if (!("keyPrefix" in value) || value["keyPrefix"] === undefined) return false;
  return true;
}

export function ApiKeyCreationResultFromJSON(json: any): ApiKeyCreationResult {
  return ApiKeyCreationResultFromJSONTyped(json, false);
}

export function ApiKeyCreationResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiKeyCreationResult {
  if (json == null) {
    return json;
  }
  return {
    apiKeyId: json["apiKeyId"],
    keyValue: json["keyValue"],
    keyPrefix: json["keyPrefix"],
  };
}

export function ApiKeyCreationResultToJSON(json: any): ApiKeyCreationResult {
  return ApiKeyCreationResultToJSONTyped(json, false);
}

export function ApiKeyCreationResultToJSONTyped(
  value?: ApiKeyCreationResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiKeyId: value["apiKeyId"],
    keyValue: value["keyValue"],
    keyPrefix: value["keyPrefix"],
  };
}
